import { useEffect, useState } from 'react';

interface Props {
  defaults?: { eventLocation?: string };
  onBack: () => void;
  onNext: (values: { eventLocation: string }) => void;
}

const MetadataWhenWhere = ({ defaults, onBack, onNext }: Props) => {
  const [eventLocation, setEventLocation] = useState<string>(defaults?.eventLocation ?? '');
  const [valid, setValid] = useState(false);

  useEffect(() => {
    setValid(eventLocation.trim().length > 0);
  }, [eventLocation]);

  return (
    <div className="theme-card p-8 bg-white">
      {/* Heading handled at page level */}
      <div className="mt-8">
        <div className="grid gap-3 md:grid-cols-12 md:items-center">
          <div className="text-left md:col-span-4 flex items-center">
            <span className="text-sm font-medium text-slate-700">Event location <span className="text-red-600">*</span></span>
          </div>
          <div className="md:col-span-6">
            <input
              type="text"
              value={eventLocation}
              onChange={(e) => setEventLocation(e.target.value)}
              placeholder="City or venue"
              className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-base text-slate-900 shadow-inner outline-none transition focus:ring-2 focus:ring-[var(--ring)]"
            />
            <p className="mt-1 text-xs text-slate-500">So we can analyze similar events in your area.</p>
          </div>
        </div>
      </div>
      <div className="mt-6 flex items-center justify-between">
        <button type="button" className="btn-secondary" onClick={onBack}>Back</button>
        <button type="button" className="btn-primary" disabled={!valid} onClick={() => onNext({ eventLocation: eventLocation.trim() })}>Next</button>
      </div>
    </div>
  );
};

export default MetadataWhenWhere;
